var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGov(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 22,
    viewBox: "0 0 61 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2133 15.5663C13.2133 20.43 10.8937 21.9991 6.20403 21.9991C4.69229 22.0029 3.19058 21.7493 1.76105 21.2485L1.96327 18.0208C3.16924 18.6849 4.52277 19.0217 5.8936 18.9989C8.21924 18.9989 9.46599 17.8859 9.46599 15.5663V14.9269H9.41948C8.54557 16.2396 7.07101 17.0035 5.51442 16.95C2.32122 16.9511 0.335327 14.4976 0.335327 10.9939C0.335327 7.4697 1.96429 4.83398 5.58217 4.83398C7.23143 4.84729 8.74401 5.76988 9.53374 7.24422H9.57924V5.10991H13.2194V15.5663H13.2133ZM6.76332 13.8164C7.50803 13.7792 8.20497 13.4319 8.69083 12.856C9.17669 12.2801 9.40875 11.5262 9.33265 10.771C9.44373 9.34448 8.39875 8.09612 6.99791 7.98183C6.92106 7.97565 6.84421 7.97256 6.76635 7.97462C5.27289 7.97462 4.49026 9.31307 4.49026 10.9305C4.49026 12.7724 5.56005 13.8133 6.76635 13.8133L6.76332 13.8164Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4134 16.932H33.8864L38.0914 5.17112H34.1899L31.8128 13.5491H31.7693L29.4184 5.17009H25.1993L29.4134 16.932Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2738 11.0565C13.2738 7.1493 16.1779 4.89453 19.9929 4.89453C23.808 4.89453 26.712 7.15342 26.712 11.0565C26.712 14.9411 23.808 17.198 19.9929 17.198C16.1779 17.198 13.2779 14.9411 13.2779 11.0565H13.2738ZM22.5886 11.0567C22.5886 9.29614 21.8343 7.73736 19.993 7.73736C18.1517 7.73736 17.3984 9.29614 17.3984 11.0567C17.3984 12.7957 18.1527 14.3514 19.993 14.3514C21.8333 14.3514 22.5886 12.7957 22.5886 11.0567Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5399 15.2742C38.5393 16.3419 37.6911 17.2071 36.6453 17.2067C35.5995 17.2063 34.7519 16.3405 34.7521 15.2728C34.7521 14.2054 35.5998 13.3398 36.6456 13.3396C37.6925 13.3396 38.5406 14.2061 38.5399 15.2745V15.2742Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9052 0H42.9215V6.69225H42.966C43.9266 5.47609 45.4081 4.8117 46.9377 4.91108C50.132 4.91108 51.8823 7.99981 51.8823 10.8507C51.8823 14.3286 50.042 17.2217 46.602 17.2217C44.9373 17.2864 43.3875 16.3595 42.6323 14.8475H42.5878V16.9499H38.9022V0H38.9052ZM45.3366 8.0185C43.8724 8.0185 42.8967 9.32709 42.8967 11.0897C42.7566 12.6053 43.8483 13.9501 45.3366 14.0951C46.8452 14.0951 47.7542 12.806 47.7542 10.9322C47.7542 9.37342 46.8897 8.01953 45.3366 8.01953V8.0185Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.132 8.42696C59.69 8.31423 59.234 8.26878 58.7789 8.29208C56.9151 8.29208 55.8745 9.6697 55.8745 11.974V16.9449H51.879V5.16929H55.5196V7.3397H55.5641C56.0671 5.86105 57.4443 4.87713 58.9812 4.8985C59.435 4.90629 59.8875 4.95139 60.3342 5.03338L60.132 8.43108V8.42696Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGov);
export default __webpack_public_path__ + "static/media/logo-gov.25513fb619a9521b3f1c7b1e8592fbf0.svg";
export { ForwardRef as ReactComponent };